
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M1.912 1.147a.765.765 0 00-.765.765v9.295c0 .357.29.646.646.646h2.69c.247 0 .488.374.488.622 0 .247-.24.525-.488.525h-2.69c-.473 0-.93-.188-1.265-.525A1.782 1.782 0 010 11.207V1.793C0 1.32.188.863.528.525A1.781 1.781 0 011.793 0h2.69c.247 0 .399.278.399.525 0 .248-.046.622-.294.622H1.912zM8.794 2.502c.189-.175.576-.175.765 0l1.53 1.53 1.91 1.912c.383.382.383.382-.382 1.147l-1.529 1.53-1.53 1.528c-.188.176-.575.176-.764 0-.189-.175-.189-.589 0-.764l3.04-3.023-3.04-3.095c-.189-.176-.188-.589 0-.765z","fill":"#fff"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.824 6.345c0-.317.206-.574.459-.574h8.259c.253 0 .459.257.459.574 0 .317-.206.574-.46.574H4.284c-.253 0-.459-.257-.459-.574z","fill":"#fff"}})])
          )
        }
      }
    